import { useEffect, useRef } from 'react';
import { Link } from "react-router-dom"

import helpImg1 from '@Images/ecos_help/helpImg-1.png';
import helpImg1_2 from '@Images/ecos_help/helpImg-1-2.png';
import helpImg2 from '@Images/ecos_help/helpImg-2.png';
import helpImg3 from '@Images/ecos_help/helpImg-3.png';
import { getLanguage } from '@Views/utils/StringUtils';

const ECOSHelp = ({ msg }: any) => {

    const searchDivRef = useRef<any>();
    const st100DivRef = useRef<any>();
    const statDivRef = useRef<any>();

    const onClickHelp = (type: number) => {

        switch (type) {
            case 1:
                searchDivRef.current?.scrollIntoView({ behavior: 'smooth' });
                break;
            case 2:
                st100DivRef.current?.scrollIntoView({ behavior: 'smooth' });
                break;
            case 3:
                statDivRef.current?.scrollIntoView({ behavior: 'smooth' });
                break;
        }

    }


    return (
        <>
            <div className="wrap-body-center">
                <div className="wrap-body-title-bg" >
                    <div className="wrap-body">
                        <div className="wrap-body-center">
                            <div className="table02-wrap-cover-1">
                                <div className="table02-wrap">
                                    <div className="table-title">
                                        <h2 className="title">{msg['ecosHelpTitle']}</h2>
                                        <p>{msg['ecosHelpTitleDesc']}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="infin-row-wrap">
                    <div className="wrap-body">
                        <div className="wrap-body-center">

                            <div className="ecos_help_con">
                                <div className="tabContainer tabContainer-01 tabContainer-yh">
                                    <div className="tabHeader">
                                        <div className="tabTitBox">
                                            <div className="tabTit">
                                                <a onClick={() => onClickHelp(1)} tabIndex={0} onKeyUp={(e) => (e.code === 'Space' || e.code === 'Enter') && onClickHelp(1)} className="btn">{msg['searchStat']}</a>
                                            </div>
                                            <div className="tabTit">
                                                <a onClick={() => onClickHelp(1)} tabIndex={0} onKeyUp={(e) => (e.code === 'Space' || e.code === 'Enter') && onClickHelp(1)} className="btn">{msg['searchStatResult']}</a>
                                            </div>
                                            <div className="tabTit">
                                                <a onClick={() => onClickHelp(2)} tabIndex={0} onKeyUp={(e) => (e.code === 'Space' || e.code === 'Enter') && onClickHelp(2)} className="btn">{msg['koreanStat100']}</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="tabContentsBox">
                                        <div className="tabItems active">

                                            <div className="help-con help-search" ref={searchDivRef}>
                                                <div className="help-con-max">
                                                    {/* 웹접근성 준수를 위해 넣음 화면 컨텐츠 순서상 h4외에 다른 heading 태그가 들어가도됨 ex)h3, h5 등등 */}
                                                    <div className="helpBox doubleImg">
                                                        <div className="txt-box">
                                                            <h4 className="tit">{msg['searchStatTitle01']}</h4>
                                                            <p className="txt" dangerouslySetInnerHTML={{ __html: msg['searchStatTitle01Desc01'] }}></p>
                                                            <p className="txt" dangerouslySetInnerHTML={{ __html: msg['searchStatTitle01Desc02'] }}></p>

                                                            <div className="shotcut">
                                                                <Link to="/SearchStat" className="helpLink helpLink01">{msg['directEnter']}</Link>
                                                            </div>
                                                        </div>
                                                        <div className="img-box">
                                                            <img src={helpImg1} alt="" />
                                                        </div>
                                                    </div>

                                                    <div className="helpBox">
                                                        <div className="img-box">
                                                            <img src={helpImg1_2} alt="" />
                                                        </div>

                                                        <div className="txt-box">
                                                            <h4 className="tit">{msg['searchStatTitle02']}</h4>
                                                            <p className="txt" dangerouslySetInnerHTML={{ __html: msg['searchStatTitle02Desc01'] }}></p>
                                                            {
                                                                getLanguage() === 'ko' &&
                                                                <>
                                                                    <p className="txt" dangerouslySetInnerHTML={{ __html: msg['searchStatTitle02Desc02'] }}></p>
                                                                    <p className="txt" dangerouslySetInnerHTML={{ __html: msg['searchStatTitle02Desc03'] }}></p>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="help-con help-st100" ref={st100DivRef}>
                                                <div className="help-con-max">
                                                    {/*웹접근성 준수를 위해 넣음 화면 컨텐츠 순서상 h4외에 다른 heading 태그가 들어가도됨 ex)h3, h5 등등*/}
                                                    <div className="helpBox">
                                                        <div className="txt-box">
                                                            <h4 className="tit">{msg['koreanStat100']}</h4>
                                                            <p className="txt" dangerouslySetInnerHTML={{ __html: msg['koreanStat100Desc01'] }}></p>
                                                            {
                                                                getLanguage() === 'ko' &&
                                                                <>
                                                                    <p className="txt" dangerouslySetInnerHTML={{ __html: msg['koreanStat100Desc02'] }}></p>
                                                                    <p className="txt" dangerouslySetInnerHTML={{ __html: msg['koreanStat100Desc03'] }}></p>
                                                                </>
                                                            }
                                                            <div className="shotcut">
                                                                <Link to="/StatisticsByTheme/KoreanStat100" className="helpLink helpLink02">{msg['directEnter']}</Link>
                                                            </div>
                                                        </div>
                                                        <div className="img-box">
                                                            <img src={helpImg2} alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}


export default ECOSHelp;